import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.73333 2.80978L8.0626 11.2726L1.69336 18.1533H3.12682L8.70308 12.1292L13.2085 18.1533H18.0867L11.4013 9.2144L17.3297 2.80978H15.8963L10.7608 8.35787L6.61145 2.80978H1.73333ZM3.84134 3.86567H6.08236L15.9783 17.0972H13.7373L3.84134 3.86567Z",
		fill: "#0D2976"
	})
});
export default SvgTwitter;
